import { LAYOUT } from '../../constant'

const user = {
  path: '/user',
  redirect: '/user/list',
  component: LAYOUT,
  meta: {
    title: '用户管理',
    orderNo: 4,
    hideChildrenInMenu: false
  },
  children: [
    {
      path: 'list',
      name: 'UserList',
      component: () => import('@/views/UserInfo.vue'),
      meta: {
        title: '用户列表'
      }
    }
  ]
}

export default user
